import { LockablePercentFieldData } from 'models/forms/fields/LockablePercentFieldMetadata';

import type { BatchWorkspaceTabContent } from './tabContent.model';

// TODO: batch screen unit test

export function isNbOfBatchFormWithinThreshold(nbOfForms: number): boolean {
  return nbOfForms <= (window?.sgmeConfiguration?.maxNumberOfFormsPerBatchTab || 100);
}

export function areSelectedFieldsInvalid(tabContent?: BatchWorkspaceTabContent): boolean {
  return !(
    tabContent &&
    tabContent.selectedFieldsIds?.length > 0 &&
    tabContent.selectedFieldsIds.every(
      id => tabContent.fields.hasOwnProperty(id) && tabContent.fields[id] !== undefined && tabContent.fields[id] !== '',
    )
  );
}

export function isXMarginFieldInvalid(tabContent: BatchWorkspaceTabContent): boolean {
  const lockFieldValue = tabContent?.fields['XMargin'] as LockablePercentFieldData;
  if (!isXMarginSelected(tabContent) || isXMarginLocked(lockFieldValue)) {
    return false;
  } else if (isXMarginUnlockedAndNull(lockFieldValue)) {
    return true;
  } else {
    return false;
  }
}

export function isXMarginValueApplicable(fieldName: string, fieldValue: any, formData: any): boolean {
  return !(fieldName === 'XMargin' && isXMarginLocked(fieldValue) && formData['SelectedOnBehalfClient'] === null);
}

export function isXMarginSelected(tabContent: BatchWorkspaceTabContent): boolean {
  return tabContent.selectedFieldsIds.includes('XMargin');
}

export function isXMarginLocked(value: LockablePercentFieldData): boolean {
  return value === null;
}

export function isXMarginUnlockedAndNull(value: LockablePercentFieldData): boolean {
  return value.value === null && value.customized === true;
}
